module.exports = __webpack_public_path__ + "img/img-status-success.25d8d7fe.png";